import withToast from './withToast';

export default withToast;
